"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductPayPerView;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _reactNativeSvg = require("react-native-svg");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _client = _interopRequireDefault(require("@sart/client"));
var _content = require("@sart/content");
var _icons = require("@sart/icons");
var _utilities = require("@sart/utilities");
var _Text = _interopRequireDefault(require("./Text"));
var _Price = _interopRequireDefault(require("./Price"));
var _Space = _interopRequireDefault(require("./Space"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var formatDate = function formatDate(date, language) {
  if (date && date !== null) {
    var formatted = (0, _moment["default"])(date).utc().locale(language).format('ddd D MMM');
    var elements = formatted.split('.').join('').split(' ');
    elements[0] = elements[0][0].toUpperCase() + elements[0].slice(1);
    elements[2] = elements[2][0].toUpperCase() + elements[2].slice(1);
    return elements.join(' ');
  }
  return null;
};
function ProductPayPerView(props) {
  var product = props.product,
    disabled = props.disabled,
    onPress = props.onPress,
    style = props.style,
    placeholderStyle = props.placeholderStyle,
    bodyStyle = props.bodyStyle,
    headerStyle = props.headerStyle,
    titleStyle = props.titleStyle,
    priceStyle = props.priceStyle,
    descriptionStyle = props.descriptionStyle,
    iconColor = props.iconColor;

  /* 
  Functions to get display information from product's Display Details 
  */

  var _useState = (0, _react.useState)(undefined),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    image = _useState2[0],
    setImage = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    imageLoading = _useState4[0],
    setImageLoading = _useState4[1];
  (0, _react.useEffect)(function () {
    getImage();
  }, []);
  function getDisplayDetailsForLanguage(product) {
    //Get the display details for the language that is selected in the cache
    var displayDetails = undefined;

    //identify the correct display details to use based on language
    if (product.displayDetails) {
      product.displayDetails.map(function (detail) {
        if (detail.language === _client["default"].cache.language) {
          displayDetails = detail;
        }
      });
    }
    return displayDetails;
  }
  function getImage() {
    return _getImage.apply(this, arguments);
  }
  function _getImage() {
    _getImage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var productImage, imageBuff, _t;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setImageLoading(true);
            _context.next = 1;
            return (0, _utilities.getProductImage)(displayDetails, 'Icon');
          case 1:
            productImage = _context.sent;
            if (_reactNative.Platform.OS === "web") {
              imageBuff = new Buffer.from(productImage);
              productImage = imageBuff.toString('base64');
            }
            setImage(productImage);
            setImageLoading(false);
            _context.next = 3;
            break;
          case 2:
            _context.prev = 2;
            _t = _context["catch"](0);
            setImageLoading(false);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 2]]);
    }));
    return _getImage.apply(this, arguments);
  }
  function getColourByCategory(displayDetails, category) {
    if (!category) {
      return undefined;
    }
    var toReturn = undefined;
    var hexCodeRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

    //get the relevant font colour based on the category
    if (displayDetails && displayDetails.colors && displayDetails.colors.length) {
      displayDetails.colors.map(function (color) {
        //we also only accept hex values, so use regex to make sure it matches the pattern
        if (color.category === category && hexCodeRegex.test(color.color)) {
          toReturn = color.color;
        } else if (color.category === category && color.color === 'transparent') {
          return undefined;
        }
      });
    }
    return toReturn;
  }
  var displayDetails = getDisplayDetailsForLanguage(product);
  var titleColour = getColourByCategory(displayDetails, 'TitleText');
  var descriptionColour = getColourByCategory(displayDetails, 'DescriptiveText');
  var backgroundColour = getColourByCategory(displayDetails, 'Background');
  var content = (0, _content.useContent)();
  var language;
  if (_client["default"].cache.language === 'en') {
    language = 'en-gb';
  } else if (_client["default"].cache.language === 'es') {
    language = 'es-us';
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: [styles.container, style, backgroundColour ? {
      backgroundColor: backgroundColour
    } : {}],
    onPress: onPress,
    disabled: disabled
  }, image && _reactNative.Platform.OS !== "web" && imageLoading == false && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.productImage, placeholderStyle]
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.SvgCss, {
    xml: image
  })), image && _reactNative.Platform.OS === "web" && imageLoading == false && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.productImageWeb, placeholderStyle]
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "data:image/svg+xml;base64,".concat(image)
  })), !image && imageLoading == false && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.placeholder, placeholderStyle]
  }, /*#__PURE__*/_react["default"].createElement(_icons.TV, {
    color: _styles.colors.white,
    size: 40
  })), imageLoading && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.loadingBackground, placeholderStyle]
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.ActivityIndicator, {
    size: "large",
    color: "blue",
    style: {
      justifyContent: 'center'
    }
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.body, bodyStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 4
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.header, headerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.title, titleStyle, titleColour ? {
      color: titleColour
    } : {}]
  }, product.productName), product.upfrontCost !== undefined && product.upfrontCost > 0 && /*#__PURE__*/_react["default"].createElement(_Price["default"], {
    value: product.upfrontCost,
    style: [styles.title, priceStyle, descriptionColour ? {
      color: descriptionColour
    } : {}],
    code: product.currency
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.header, headerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.description, descriptionStyle, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, product.description), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.description, descriptionStyle, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, "Billed")), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.header, headerStyle]
  }, product.expiration && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [styles.description, descriptionStyle, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, content.product.expiryDate + formatDate(product.expiration, language)))));
}
ProductPayPerView.propTypes = {
  product: _propTypes["default"].object,
  onPress: _propTypes["default"].func
};
var styles = _reactNative.StyleSheet.create({
  container: _objectSpread({
    height: 72,
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: _styles.backgroundColors.clear,
    elevation: 8
  }, _styles.shadows.shadowByElevation(8)),
  placeholder: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: _styles.backgroundColors.white,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8
  },
  loadingBackground: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8
  },
  body: {
    flex: 1,
    // padding: 12,
    paddingLeft: 12,
    paddingRight: 12,
    backgroundColor: 'white'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: _objectSpread(_objectSpread({
    fontSize: 14,
    lineHeight: 20
  }, _styles.typography.lightbold), {}, {
    color: _styles.colors.black
  }),
  price: _objectSpread(_objectSpread({
    fontSize: 14,
    lineHeight: 20
  }, _styles.typography.lightbold), {}, {
    color: _styles.colors.feature
  }),
  description: _objectSpread({
    fontSize: 14,
    lineHeight: 20,
    color: _styles.colors.focus
  }, _styles.typography.medium),
  productImage: {
    // marginTop: 12,
    width: 72,
    // alignItems: 'center',
    // justifyContent: 'center',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8
  }
});